/* Off Duty: swatches + quick size add on product cards */
(function () {
  function card(el) { return el.closest('.od-shop'); }
  function dataOf(shop) { if (!shop._d) shop._d = JSON.parse(shop.querySelector('.od-data').textContent); return shop._d; }
  function swapImage(shop, url, hoverUrl) {
    var media = shop.closest('.card-wrapper') || shop.closest('.card');
    var images = media && media.querySelectorAll('.card__media img');
    if (!images || !images[0] || !url) return;
    hoverUrl = hoverUrl || url;
    var wanted = url + '|' + hoverUrl;
    shop._want = wanted;
    var urls = [url, hoverUrl];
    var loads = urls.map(function (src) {
      var pre = new Image(); pre.src = src;
      return pre.decode ? pre.decode().catch(function () {}) : Promise.resolve();
    });
    Promise.all(loads).then(function () {
      if (shop._want !== wanted) return;
      images.forEach(function (img, index) {
        if (index > 1) return;
        img.removeAttribute('srcset'); img.src = urls[index];
        img.alt = selectedColor(shop) + (index ? ', alternate view' : ', front view');
      });
    });
  }
  /* warm the browser cache with every colour of a card as soon as it is near the viewport (and on hover) — swatch clicks then swap instantly */
  function preload(shop) {
    if (shop._pre) return; shop._pre = true;
    shop.querySelectorAll('.od-swatch[data-image]').forEach(function (b) { var i = new Image(); i.decoding = 'async'; i.fetchPriority = 'low'; i.src = b.dataset.image; });
  }
  function watchCards() {
    var shops = document.querySelectorAll('.od-shop');
    if (!('IntersectionObserver' in window)) { shops.forEach(preload); return; }
    var io = new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (en.isIntersecting) { preload(en.target); io.unobserve(en.target); } }); }, { rootMargin: '300px' });
    shops.forEach(function (s) { if (!s._pre) io.observe(s); });
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchCards); else watchCards();
  document.addEventListener('pointerover', function (e) { var s = e.target.closest && e.target.closest('.od-shop'); if (s) preload(s); }, { passive: true });
  function selectedColor(shop) { var a = shop.querySelector('.od-swatch.is-active'); return a ? a.dataset.color : null; }
  function addToCart(shop, variantId, btn) {
    var body = new FormData();
    body.append('id', variantId); body.append('quantity', 1);
    var note = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (note && note.getSectionsToRender) {
      body.append('sections', note.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      body.append('sections_url', window.location.pathname);
    }
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch(window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add', { method: 'POST', headers: { 'Accept': 'application/json' }, body: body })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (json.status) throw new Error(json.description || 'error');
        if (note && note.renderContents) { note.renderContents(json); } else { window.location.href = '/cart'; }
        restore(shop, 'Added ✓');
      })
      .catch(function () { restore(shop, 'Try again'); });
  }
  function restore(shop, label) {
    var sizes = shop.querySelector('.od-sizes'), add = shop.querySelector('.od-add'), name = shop.querySelector('.od-color-name');
    sizes.hidden = true; sizes.innerHTML = ''; sizes.classList.remove('is-busy'); shop.classList.remove('is-open'); add.hidden = false; add.disabled = false; add.textContent = label || 'Add to cart';
    if (name && shop._colorText != null) { name.textContent = shop._colorText; shop._colorText = null; }
    if (label && label !== 'Add to cart') setTimeout(function () { add.textContent = 'Add to cart'; }, 2500);
  }
  function showSizes(shop) {
    var d = dataOf(shop), add = shop.querySelector('.od-add'), box = shop.querySelector('.od-sizes');
    if (d.variant) { addToCart(shop, d.variant, add); return; }
    var color = selectedColor(shop) || d.colors[0].name;
    var c = d.colors.filter(function (x) { return x.name === color; })[0]; if (!c) return;
    /* the button turns into a row of sizes of the same height; the colour line above becomes the prompt */
    box.innerHTML = '';
    c.sizes.forEach(function (s) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'od-size'; b.textContent = s.size; b.disabled = !s.available; b.dataset.id = s.id;
      b.setAttribute('aria-label', (s.available ? 'Add size ' : 'Sold out: ') + s.size); box.appendChild(b);
    });
    var x = document.createElement('button'); x.type = 'button'; x.className = 'od-size od-size--close'; x.textContent = '\u00d7'; x.setAttribute('aria-label', 'Close'); box.appendChild(x);
    var name = shop.querySelector('.od-color-name');
    if (name) { if (shop._colorText == null) shop._colorText = name.textContent; name.textContent = 'Pick a size \u00b7 ' + color; }
    add.hidden = true; box.hidden = false; shop.classList.add('is-open');
  }
  function closeAll(except) { document.querySelectorAll('.od-shop.is-open').forEach(function (s) { if (s !== except) restore(s); }); }
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.od-swatch');
    if (sw) {
      e.preventDefault(); var shop = card(sw);
      shop.querySelectorAll('.od-swatch').forEach(function (b) { b.classList.toggle('is-active', b === sw); });
      var name = shop.querySelector('.od-color-name'); if (name) name.textContent = sw.dataset.color;
      swapImage(shop, sw.dataset.image, sw.dataset.hover);
      var link = shop.querySelector('.od-data').dataset.url, heading = shop.closest('.card-wrapper') && shop.closest('.card-wrapper').querySelectorAll('a.full-unstyled-link');
      if (heading && sw.dataset.variant) heading.forEach(function (a) { a.href = link + '?variant=' + sw.dataset.variant; });
      if (!shop.querySelector('.od-sizes').hidden) showSizes(shop);
      return;
    }
    var add = e.target.closest('.od-add');
    if (add) { e.preventDefault(); var sh = card(add); closeAll(sh); if (sh.classList.contains('is-open')) { restore(sh); } else { showSizes(sh); } return; }
    var size = e.target.closest('.od-size');
    if (size && size.classList.contains('od-size--close')) { e.preventDefault(); restore(card(size)); return; }
    if (size && !size.disabled) { e.preventDefault(); var cs = card(size), row = cs.querySelector('.od-sizes'); if (row.classList.contains('is-busy')) return; row.classList.add('is-busy'); size.classList.add('is-chosen'); addToCart(cs, size.dataset.id, cs.querySelector('.od-add')); return; }
    if (!e.target.closest('.od-shop')) closeAll(null);
  });
})();
